import { NotificationMenu } from 'modules/notifications/components/notifications-menu'
import React from 'react'
import DesktopMenuItem from 'shared/components/header/components/desktop-menu/components/desktop-menu-item'
import DesktopMenuSkeleton from 'shared/components/header/components/desktop-menu/components/desktop-menu-skeleton'
import { useMenuItems } from 'shared/components/header/hooks/use-menu-items'
import useUser from 'shared/hooks/use-user'

export function DesktopMenu() {
  const { isLoading, user } = useUser()
  const { menuItems } = useMenuItems()
  if (isLoading) {
    return <DesktopMenuSkeleton />
  } else if (!user) {
    return null
  }

  return (
    <div className={`flex h-full items-center gap-4`}>
      {menuItems.map((item, idx) => {
        return <DesktopMenuItem key={idx} item={item} />
      })}
      <NotificationMenu />
    </div>
  )
}
